import SuperRepository from '../superRepository'

export default new (class OfferPartnerLandingRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_landing'
  }
  updateLanding = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}`, params)
})()